import { render, staticRenderFns } from "./time-from-now.vue?vue&type=template&id=1f38b685&lang=pug&"
import script from "./time-from-now.vue?vue&type=script&lang=js&"
export * from "./time-from-now.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports